import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    checkbox: {
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
        p: 0,
    },
    button: {
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
        p: 0,
    },
    list: {
        mt: 3,
        pb: 2,
        backgroundColor: palette.grey[50],
    },
    nestedList: {},
    nestedListItem: {
        mb: 1,
    },
    nestedListItemIcon: {
        fontSize: 12,
        m: 0,
    },
    nestedListItemText: {
        ml: 1,
        fontSize: 12,
    },
    countBox: {
        minWidth: 25,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    countBoxSelected: {
        backgroundColor: palette.primary.extraLight,
    },
    count: {},
}
